import 'core-js/stable';
import { LoginRouter } from 'auto-converted/routers/LoginRouter';
import { Cvpartner, setCvPartner } from '../Cvpartner';
import '../../assets/stylesheets/application.scss';
import '../components/navigation';

// Here be dragons
setCvPartner(new Cvpartner(LoginRouter));
